<template>
  <div class="">
    <div v-if="!isOrderDetail">
      <div>

        <!-- 查询表单 -->
        <el-form ref="form" :model="orderProgramFrom" label-width="100px">
          <el-row :gutter="20" class="mb8">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
              <el-form-item label="月份">
                <el-date-picker  v-model="orderProgramFrom.queryMonth"
                  type="month"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  placeholder="选择年月"
                  @change="changeMonth"
                  >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
              <el-form-item label="下单时间">
                <el-date-picker clearable
                                v-model="orderProgramFrom.createTime"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions1">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
              <el-form-item label="订单编号">
                <el-input clearable v-model="orderProgramFrom.orderNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
              <el-form-item label="订单状态">
                <el-select clearable v-model="orderProgramFrom.status" placeholder="请选择">
                  <el-option
                      v-for="item in statusOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" v-if="userType!=0">
              <el-form-item label="渠道名称">
                <el-input clearable v-model="orderProgramFrom.merchantName" placeholder="请输入渠道名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
              <el-form-item label="渠道订单编号" label-width="120px">
                <el-input clearable v-model="orderProgramFrom.openOrderNo" placeholder="请输入渠道订单编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-button type="primary" @click="getOrderList">查询</el-button>
              <el-button type="primary" @click="showExportTaskDlg">导出数据</el-button>
              <el-button type="primary" @click="showExportTask">导出记录</el-button>
            </el-col>
          </el-row>
        </el-form>


      </div>
      <div>

        <!-- 表格 -->
        <el-table
            :data="tableData"
            border>
          <el-table-column
              prop="orderNo"
              align="center"
              width="150"
              label="订单编号">
              <!-- <template slot-scope="scope"> 
                  <a class="order-link" @click="goToOrderDetail(scope.row)">{{ scope.row.orderNo }}</a>
              </template> -->
          </el-table-column>
          <el-table-column
              prop="openOrderNo"
              align="center"
              label="渠道订单编号">
          </el-table-column>
          <el-table-column
              prop="merchantName"
              align="center"
              label="渠道名称">
          </el-table-column>
          <el-table-column
              align="center"
              prop="serviceName"
              width="120"
              label="回收商名称">
          </el-table-column>
          <el-table-column
              prop="realName"
              align="center"
              width="150"
              label="报价员">
          </el-table-column>
          <el-table-column
              align="center"
              width="100"
              prop="originQuote"
              label="原始价格">
              <template slot-scope="scope">
              {{ scope.row.originQuote > 0 ? scope.row.originQuote : ""}}
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              width="100"
              prop="quote"
              label="成交价格">
              <template slot-scope="scope">
              {{ scope.row.quote > 0 ? scope.row.quote : ""}}
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              width="80"
              prop="statusDesc"
              label="订单状态">
          </el-table-column>
        
          <el-table-column
              prop="createTime"
              width="200"
              align="center"
              label="创建时间">
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination style="margin-top: 20px;"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-sizes="[10, 20, 40, 100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="tableTotal">
        </el-pagination>

      </div>

      <el-dialog title="导出任务列表" center :visible.sync="exportTaskListDlg" width="800px">
        <div style="margin: 20px; text-align: center;">
          <div>
            <el-table
                :data="exportTaskData"
                border
                style="max-width: 99%">
              <el-table-column
                  prop="taskRemark"
                  align="center"
                  label="任务备注">
              </el-table-column>
              <el-table-column
                  prop="taskStatus"
                  align="center"
                  label="任务状态">
                <template scope="scope">
                  {{ scope.row.taskStatus === 0 ? '待处理' : '' }}
                  {{ scope.row.taskStatus === 1 ? '处理中' : '' }}
                  {{ scope.row.taskStatus === 2 ? '处理完成' : '' }}
                  {{ scope.row.taskStatus === 3 ? '处理失败' : '' }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="createTime"
                  align="center"
                  label="创建时间">
              </el-table-column>
              <el-table-column
                  align="center"
                  label="下载地址">
                <template slot-scope="scope">
                  <el-link :href="scope.row.downloadUrl" v-show="scope.row.downloadUrl">下载</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <!-- 分页 -->
            <el-pagination style="margin-top: 20px;"
                          @size-change="handleExportSizeChange"
                          @current-change="handleExportCurrentChange"
                          :current-page="exportCurrentPage"
                          :page-sizes="[10, 20, 40, 100]"
                          :page-size="exportPageSize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="exportTableTotal">
            </el-pagination>
          </div>
        </div>
      </el-dialog>

      <el-dialog title="新建导出任务" center :visible.sync="exportTaskDlg" width="400px">
        <div style="margin: 20px; text-align: center;">
          <div>
            <el-form ref="changeStatusFrom" :model="orderProgramFrom" label-width="80px">
              <el-form-item prop="taskType" label="任务类型">
                <el-radio v-model="taskType" label="4">导出报价记录订单</el-radio>
              </el-form-item>
              <el-form-item prop="orderStatus" label="任务备注">
                <el-input clearable v-model="orderProgramFrom.taskRemark" placeholder="任务备注"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <el-button type="primary" style="margin: 10px 20px;" @click="addExportTask()">确定</el-button>
            <el-button style="margin: 10px 20px;" @click="closeExportTaskDlg()">取消</el-button>
          </div>
        </div>
      </el-dialog>

      </div>
    <div v-if="isOrderDetail">
      <div class="content">
          <el-form
            ref="orderDetailData"
            :model="orderDetailData"
            label-width="130px"
          >
      <div>
        <el-row style="margin-bottom: 20px; margin-top: 30px;">
          <el-col :span="8">订单编号: {{orderDetailData.orderNO}}</el-col>
          <el-col :span="8">下单时间: {{orderDetailData.createTime}}</el-col>
          <el-col :span="8">订单状态: {{orderDetailData.statusDesc}}</el-col>
        </el-row>

        <el-row style="margin-bottom: 20px;">
          <el-col :span="8">商户: {{orderDetailData.merchantName}}</el-col>
          <el-col :span="8">门店: {{orderDetailData.storeName}}</el-col>
          <el-col :span="8">店员: {{orderDetailData.employeeName}}</el-col>
        </el-row>

        <el-row style="margin-bottom: 20px;">
          <el-col :span="8">机型: {{orderDetailData.modelName}}</el-col>
          <el-col :span="8">IMEI: {{orderDetailData.imei}}</el-col>
          <el-col :span="8" v-if="orderDetailData.canQualityData">中标服务商: {{orderDetailData.serviceName}}</el-col>
        </el-row>
        <el-row>
                <el-image
                  v-for="(item, index) in orderDetailData.orderAttachmentList"
                  :key="index"
                  :src="item.url"
                  fit="fill"
                  style="width: 150px; height: 150px; margin: 10px"
                  :preview-src-list="[item.url]"
                >
                </el-image>
        </el-row>

        <el-row>
          <el-table :data="orderDetailTableData" style="width: 100%" border >
            <el-table-column prop="qualityCheck" label="质检项" width="200px" header-align="center" align="center">
              <template slot-scope="scope">
                <div :class="{ 'separator-row': scope.row.type === 'separator','gray-background': true }">{{ scope.row.qualityCheck }}</div>
              </template>
            </el-table-column>

            <el-table-column prop="employeeOption" label="店员选项" width="200px" header-align="center" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <!-- 使用 <div> 标签包裹，添加样式以保持换行 -->
                <div style="white-space: pre-line;" :class="{ 'separator-row': scope.row.type === 'separator' }">{{ scope.row.employeeOption }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="quoteStaffOption" label="报价价员选项" width="200px" header-align="center" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <!-- 使用 <div> 标签包裹，添加样式以保持换行 -->
                <div style="white-space: pre-line;" :class="{ 'separator-row': scope.row.type === 'separator' }">{{ scope.row.quoteStaffOption }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="inspectorOption" label="质检员选项" width="200px" header-align="center" align="center" show-overflow-tooltip
            v-if="orderDetailData.canQualityData">
              <template slot-scope="scope">
                <!-- 使用 <div> 标签包裹，添加样式以保持换行 -->
                <div style="white-space: pre-line;" :class="{ 'separator-row': scope.row.type === 'separator' }">{{ scope.row.inspectorOption }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="hasDifference" label="是不是存在差异" width="200px" header-align="center" align="center" 
            show-overflow-tooltip v-if="orderDetailData.canQualityData">
              <template slot-scope="scope">
                <div :class="{ 'separator-row': scope.row.type === 'separator' }">{{ scope.row.hasDifference }}</div>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>


          </el-form>

            <div style="display: flex; justify-content: center;margin-top:10px">
              <el-button style="margin: 10px 20px;" @click="returnBack()">返回订单列表</el-button>
          </div>
      </div>

    </div>


  </div>
</template>

<script>
import { ITEM_OPTIONS } from '../const/item-options'
import XLSX from "xlsx";
import FileSaver from "file-saver";

export default {
  components: {},
  props: {},
  data() {
    return {
      isOrderDetail: false,

      orderDetailTableData: [
      ],

      qualityConditionItemsMap: {},
      qualityFunctionItemsMap: {},
      qualityRemarkItemsMap:{},
      qualityItemTemp: {
        id: null,
        qualityCheck: null,
        employeeOption: null,
        quoteStaffOption: null,
        inspectorOption: null,
        hasDifference: "",
      },


      // 表单详情的数据
      orderDetailData: {
        orderNo: null,
        createTime: null,
        statusDesc: null,
        merchantName: null,
        storeName: null,
        employeeName: null,
        modelName: null,
        imei: null,
        serviceName: null,
        canQualityData: false,
        quotePrice:null,
        brokerage:null,
        employeeRedPackage:null,
        redPackage:null,
        mainPersonCommission:null,
        price:null,
        remark:null,
        quoteRemark:null,
        qualityRemark:null,
      },
      merchantList: [],
      merchantId: '',
      selectIndex: 0,
      statisInfo: null,
      selectList: ['本月', '今年', '去年'],
      // 用户类型（权限）
      userType: 0,

      taskType: '4',

      userInfo: {},

      exportQualityTaskDlg: false,
     
      // 查询表单数据
      orderProgramFrom: {
        brandId: null,
        queryMonth:new Date(Date.now()).toISOString().slice(0,7),
        createTime: [new Date(Date.now()).toISOString().slice(0,10), new Date().toISOString().slice(0,10)],
        modalId: null,
        employeeLike: null,
        imei: null,
        merchantLike: null,
        orderNo: null,
        status: null,
        storeLike: null,
        taskRemark: null,
        openOrderNo: null,
        merchantName: null
      },
      // 日期选择插件配置

      //限制
      pickerOptions1: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
          console.log(obj)
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = 60 * 24 * 3600 * 1000
            let maxTime = this.pickerMinDate + day1
            let minTime = this.pickerMinDate - day1
            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now()
          } else {
            return time.getTime() > Date.now()
          }

        }
      },

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },


      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      exportTaskData: [],
      exportPageSize: 2,
      exportCurrentPage: 1,
      exportTableTotal: 0,
      exportTaskListDlg: false,

      // 品牌选择框
      brandOptions: [],

      exceptionRemarkOptions:[{
        id: 1,
        name: '申请追责'
      }, {
        id: 2,
        name: '其他'
      }, {
        id: 3,
        name: '物流丢失'
      },{
        id: 4,
        name: '门店发错货-需寄回'
      }, {
        id: 5,
        name: '门店发错货-无需寄回'
      }],

      // 订单状态选择框
      statusOptions: [{
        id: 1,
        name: '待报价'
      }, {
        id: 2,
        name: '待确认'
      }, {
        id: 3,
        name: '待付款'
      }, {
        id: 4,
        name: '待发货'
      }, {
        id: 5,
        name: '待收货'
      }, {
        id: 6,
        name: '待验机'
      }, {
        id: 7,
        name: '已取消'
      }, {
        id: 8,
        name: '报价中'
      }, {
        id: 15,
        name: '待销售'
      }, {
        id: 17,
        name: '物流签收'
      }, {
        id: 18,
        name: '暂停收货'
      }, {
        id: 19,
        name: '超时收货'
      }, {
        id: 20,
        name: '异常退货'
      },{
         id: 13,
        name: '未中标'
      }],

      // 型号选择框
      nmodalIdameOptions: [],


      //  开关取消订单对话框
      cancelOrderDlg: false,

      exportTaskDlg: false,

      //  开关修改状态对话框
      changeStatuDlg: false,

      // 当前编辑中的订单编号
      changingOrderNo: null,

      // 修改状态数据
      changeStatusForm: {
        status: 1,
        expressNo:null,
        recyclableOrderNo:null,
        imei:null,
        exceptionType:1
      },

      // 修改状态验证
      changeStatusRules: {
        status: [
          {required: true, message: '请选择修改状态', trigger: 'change'},
        ],
      },
      fullscreenLoading: false,
      isAdmin: JSON.parse(localStorage.getItem("userInfo")).data.roleId == 1,
      isReceiveMerchentAdmin: JSON.parse(localStorage.getItem("userInfo")).data.roleId == 9,
      fullscreenQualityLoading: false,
      isDlg: false,
      qualityInfoForm: {}
    }
  },
  watch: {},
  computed: {
  },
  methods: {
    changeMonth(){
        this.orderProgramFrom.createTime=null;
    },
    getMerchantList() {
      this.$api.getMymerchant().then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.merchantList = res.data;
          if (this.merchantList && this.merchantList.length) {
            this.merchantId = this.merchantList[0].id
            this.getData()
          }
        }
      })
    },
    getQualityConditionItemById(id) {
      if (this.qualityConditionItemsMap[id]) {
        // If the qualityItem with the given id exists in the map, return it
        return this.qualityConditionItemsMap[id];
      } else {
        // If the qualityItem with the given id doesn't exist, create a new one
        const newQualityItem = { ...this.qualityConditionItemsMap, id: id };
        // Add the new qualityItem to the map
        this.qualityConditionItemsMap[id] = newQualityItem;
        // Return the new qualityItem
        return newQualityItem;
      }
    },
    getQualityFunctionItemById(id) {
      if (this.qualityFunctionItemsMap[id]) {
        // If the qualityItem with the given id exists in the map, return it
        return this.qualityFunctionItemsMap[id];
      } else {
        // If the qualityItem with the given id doesn't exist, create a new one
        const newQualityItem = { ...this.qualityFunctionItemsMap, id: id };
        // Add the new qualityItem to the map
        this.qualityFunctionItemsMap[id] = newQualityItem;
        // Return the new qualityItem
        return newQualityItem;
      }
    },
    getQualityRemarkItemById(id) {
      if (this.qualityRemarkItemsMap[id]) {
        // If the qualityItem with the given id exists in the map, return it
        return this.qualityRemarkItemsMap[id];
      } else {
        // If the qualityItem with the given id doesn't exist, create a new one
        const newRemarkItem = { ...this.qualityRemarkItemsMap, id: id };
        // Add the new qualityItem to the map
        this.qualityRemarkItemsMap[id] = newRemarkItem;
        // Return the new qualityItem
        return newRemarkItem;
      }
    },
    
    goToOrderDetail(row) {
      // 在点击事件中处理跳转到订单详情页
      this.isOrderDetail = true;

      //获取对应的order详情信息
      this.$api.getAdminOrderHistoryDetail({
          orderNo: row.orderNO,
          createTime: row.createTime
        }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.orderDetailData = res.data;
          this.orderDetailTableData = [];

          //处理订单详情的信息
          const parsedObjectCreateOrderModelParam = JSON.parse(res.data.storeModelParam);
          const parsedObjectQuoteModelParam = JSON.parse(res.data.quoteModelParam);
          const parsedObjectQualityModelParam = JSON.parse(res.data.qualityModelParam);

          //处理物品信息
          const orderItemTagList = [];
          ITEM_OPTIONS.forEach(item => 
          {
              if (item.id === 'sku_memory') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuMemory',item);
              } else if (item.id === 'sku_purchase_channel') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuPurchaseChannel',item);
              } else if (item.id === 'sku_body_color') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuBodyColor',item);
              } else if (item.id === 'sku_warranty_duration') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuWarrantyDuration',item); 
              } else if (item.id === 'sku_small_model') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuSmallModel',item); 
              } else if (item.id === 'sku_network') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuNetwork',item); 
              } else if (item.id === 'sku_cpu') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuCpu',item); 
              } else if (item.id === 'sku_graphics_card') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuGraphicsCard',item);   
              } else if (item.id === 'sku_solid_drive') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuSolidDrive',item);     
              } else if (item.id === 'sku_mechanical_drive') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuMechanicalDrive',item);    
              }else if (item.id === 'sku_charging_interface') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuChargingInterface',item);    
              }else if (item.id === 'sku_charging_method') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuChargingMethod',item);    
              }else if (item.id === 'sku_case_size') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuCaseSize',item);    
              }else if (item.id === 'sku_case_material') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuCaseMaterial',item);    
              }else if (item.id === 'sku_watch_strap') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuWatchStrap',item);    
              }else if (item.id === 'sku_strap_color') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuStrapColor',item);    
              }else if (item.id === 'sku_left_right_ear') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuLeftRightEar',item);    
              }else if (item.id === 'sku_external_keyboard') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuExternalKeyboard',item);    
              }else if (item.id === 'sku_accessories_situation') {
                this.pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,
                'skuAccessoriesSituation',item);    
              }
          });

          const separator = {
            type: "separator",
          };
          
          this.orderDetailTableData.push(separator);

          //处理成色信息
          this.qualityConditionItemsMap = [];
          const parsedObjectCreateOrderConditionParam = JSON.parse(res.data.storeConditionParam);
          const parsedObjectQuoteConditionParam = JSON.parse(res.data.quoteConditionParam);
          const parsedObjectQualityConditionParam = JSON.parse(res.data.qualityConditionParam);

          if(parsedObjectCreateOrderConditionParam){
            parsedObjectCreateOrderConditionParam.forEach(item => {
              this.getQualityConditionItemById(item.name).qualityCheck = item.name;
              const childrenSelected = item.children.find(child => child.selected);
              if(childrenSelected != null){
                this.getQualityConditionItemById(item.name).employeeOption = childrenSelected.name;
              }
            }
            );
          }


          if(parsedObjectQuoteConditionParam){
            parsedObjectQuoteConditionParam.forEach(item => {
              this.getQualityConditionItemById(item.name).qualityCheck = item.name;
              const childrenSelected = item.children.find(child => child.selected);
              if(childrenSelected != null){
                this.getQualityConditionItemById(item.name).quoteStaffOption = childrenSelected.name;
              }
            }
            );
          }


          if(parsedObjectQualityConditionParam){
            parsedObjectQualityConditionParam.forEach(item => {
              this.getQualityConditionItemById(item.name).qualityCheck = item.name;
              const childrenSelected = item.children.find(child => child.selected);
              if(childrenSelected != null){
                this.getQualityConditionItemById(item.name).inspectorOption = childrenSelected.name;
              }
            }
            );
          }


          for (const item of Object.values(this.qualityConditionItemsMap)) {
            // Access each item in the loop and do something
            this.orderDetailTableData.push(item);
          }

          this.orderDetailTableData.push(separator);

          //处理功能信息信息
          this.qualityFunctionItemsMap = [];
          const parsedObjectCreateOrderFunctionParam = JSON.parse(res.data.storeFunctionParam);
          const parsedObjectQuoteFunctionParam = JSON.parse(res.data.quoteFunctionParam);
          const parsedObjectQualityFunctionParam = JSON.parse(res.data.qualityFunctionParam);


          if(parsedObjectCreateOrderFunctionParam){
            parsedObjectCreateOrderFunctionParam.forEach(item => {
              if(item.multipleChoice != null && item.multipleChoice == 2){
                this.getQualityFunctionItemById(item.name).qualityCheck = item.name;
                const selectedOptions = item.children.filter(child => child.selected);
                if (selectedOptions.length > 0) {
                  const employeeOptionNames = selectedOptions.map(option => option.name).join(" | ");
                  this.getQualityFunctionItemById(item.name).employeeOption = employeeOptionNames;
                }

              }else{
                this.getQualityFunctionItemById(item.name).qualityCheck = item.name;
                const childrenSelected = item.children.find(child => child.selected);
                if(childrenSelected != null){
                  this.getQualityFunctionItemById(item.name).employeeOption = childrenSelected.name;
                }
              }
            }
            );
          }

          if(parsedObjectQuoteFunctionParam){
            parsedObjectQuoteFunctionParam.forEach(item => {
              if(item.multipleChoice != null && item.multipleChoice == 2){
                this.getQualityFunctionItemById(item.name).qualityCheck = item.name;
                const selectedOptions = item.children.filter(child => child.selected);
                if (selectedOptions.length > 0) {
                  const names = selectedOptions.map(option => option.name).join(" | ");
                  this.getQualityFunctionItemById(item.name).quoteStaffOption = names;
                }
              }else{
                this.getQualityFunctionItemById(item.name).qualityCheck = item.name;
                const childrenSelected = item.children.find(child => child.selected);
                if(childrenSelected != null){
                  this.getQualityFunctionItemById(item.name).quoteStaffOption = childrenSelected.name;
                }
              }
            }
            );
          }

          if(parsedObjectQualityFunctionParam){
            parsedObjectQualityFunctionParam.forEach(item => {
              if(item.multipleChoice != null && item.multipleChoice == 2){
                this.getQualityFunctionItemById(item.name).qualityCheck = item.name;
                const selectedOptions = item.children.filter(child => child.selected);
                if (selectedOptions.length > 0) {
                  const names = selectedOptions.map(option => option.name).join(" | ");
                  this.getQualityFunctionItemById(item.name).inspectorOption = names;
                }
              }else{
                this.getQualityFunctionItemById(item.name).qualityCheck = item.name;
                const childrenSelected = item.children.find(child => child.selected);
                if(childrenSelected != null){
                  this.getQualityFunctionItemById(item.name).inspectorOption = childrenSelected.name;
                }  
              }
            }
            );
          }



          for (const item of Object.values(this.qualityFunctionItemsMap)) {
            // Access each item in the loop and do something
            this.orderDetailTableData.push(item);
          }



          // 假设您已经定义了 orderDetailTableData 数组
          // 循环遍历 orderDetailTableData
          for (const item of this.orderDetailTableData) {
            // 判断 employeeOption 和 quoteStaffOption 是否不相等
            console.log(item.quoteStaffOption);
            console.log(item.inspectorOption);
            if (item.quoteStaffOption !== item.inspectorOption) {
              // 如果不相等，将 hasDifference 设置为 "是"
              item.hasDifference = "是";
            }
            console.log(item.hasDifference);
          }

        //   // Assuming qualityConditionParam is an array
        //   option.children = option.children.filter(child => child.selected);
        //   return option;
        // });

      //管理员才能看到价格
      if(this.userInfo.roleId ===1||this.userInfo.roleId ===4){
          //处理价格信息
          const qualityItemPriceTemp = {
            id:null,
            qualityCheck: "价格",
            employeeOption: null,
            quoteStaffOption: null,
            inspectorOption: null,
            hasDifference: "",
          };

          //价格
          const parsedObjectcreateOrderQuoteDetail = JSON.parse(res.data.storeTimePriceDetail);
          const parsedObjectcreateQuoteTimePriceDetail = JSON.parse(res.data.quoteTimePriceDetail);
          const parsedObjectcreateQualityTimePriceDetail = JSON.parse(res.data.qualityTimePriceDetail);
          if(parsedObjectcreateOrderQuoteDetail){
            qualityItemPriceTemp.employeeOption = this.getHTMLString(parsedObjectcreateOrderQuoteDetail);
          }
          if(parsedObjectcreateQuoteTimePriceDetail){
            //这里报价使用order表当中的信息
            parsedObjectcreateQuoteTimePriceDetail.price = this.orderDetailData.quotePrice;
            parsedObjectcreateQuoteTimePriceDetail.brokerage = this.orderDetailData.brokerage;
            parsedObjectcreateQuoteTimePriceDetail.employeeRedPackage = this.orderDetailData.employeeRedPackage;
            parsedObjectcreateQuoteTimePriceDetail.redPackage = this.orderDetailData.redPackage;
            parsedObjectcreateQuoteTimePriceDetail.mainPersonCommission = this.orderDetailData.mainPersonCommission;
            qualityItemPriceTemp.quoteStaffOption = this.getHTMLString(parsedObjectcreateQuoteTimePriceDetail);
          }
          if(parsedObjectcreateQualityTimePriceDetail){
            qualityItemPriceTemp.inspectorOption = this.getHTMLString(parsedObjectcreateQualityTimePriceDetail);
          }
            this.orderDetailTableData.push(qualityItemPriceTemp);
          }
         
          //处理备注信息
          const qualityItemRemarkTemp = {
            id:null,
            qualityCheck: "备注",
            employeeOption: this.orderDetailData.remark,
            quoteStaffOption: this.orderDetailData.quoteRemark,
            inspectorOption: this.orderDetailData.qualityRemark,
            hasDifference: "",
          };

          this.orderDetailTableData.push(qualityItemRemarkTemp);


          //处理质检备注信息
          this.qualityRemarkItemsMap = [];
          const parsedObjectQualityRemarkParam = JSON.parse(res.data.qualityRemarkParam);

          if(parsedObjectQualityRemarkParam){
            parsedObjectQualityRemarkParam.forEach(item => {
              if(item.multipleChoice != null && item.multipleChoice == 2){
                this.getQualityRemarkItemById(item.name).qualityCheck = item.name;
                const selectedOptions = item.children.filter(child => child.selected);
                if (selectedOptions.length > 0) {
                  const names = selectedOptions.map(option => option.name).join(" | ");
                  this.getQualityRemarkItemById(item.name).inspectorOption = names;
                }
              }else{
                this.getQualityRemarkItemById(item.name).qualityCheck = item.name;
                const childrenSelected = item.children.find(child => child.selected);
                if(childrenSelected != null){
                  this.getQualityRemarkItemById(item.name).inspectorOption = childrenSelected.name;
                }  
              }
            }
            );
          }



          for (const item of Object.values(this.qualityRemarkItemsMap)) {
            // Access each item in the loop and do something
            this.orderDetailTableData.push(item);
          }
          console.log(this.orderDetailData.orderNo);
        }
      })
    },

    pushDataToTable(parsedObjectCreateOrderModelParam,parsedObjectQuoteModelParam,parsedObjectQualityModelParam,optionType,optionItem){
      const qualityTtemTemp = {
        id:null,
        qualityCheck: null,
        employeeOption: null,
        quoteStaffOption: null,
        inspectorOption: null,
        hasDifference: "",
      };
      qualityTtemTemp.id = optionItem.id;
      qualityTtemTemp.qualityCheck = optionItem.name;

      let needPush = true;
      // console.log(optionType)
      // console.log(parsedObjectCreateOrderModelParam[optionType])
      // console.log(parsedObjectQuoteModelParam[optionType])
      // console.log(parsedObjectQualityModelParam[optionType])

      if((parsedObjectCreateOrderModelParam == null || parsedObjectCreateOrderModelParam[optionType] == null || parsedObjectCreateOrderModelParam[optionType].length == 0)
          && (parsedObjectQuoteModelParam == null || parsedObjectQuoteModelParam[optionType] == null || parsedObjectQuoteModelParam[optionType].length == 0) 
          && (parsedObjectQualityModelParam == null || parsedObjectQualityModelParam[optionType] == null || parsedObjectQualityModelParam[optionType].length == 0 ) 
        ){
          needPush = false;
        }else{
        //添加店员的选项
          // If the array is not empty, return the createOrderModelParam field from the first item
        if(parsedObjectCreateOrderModelParam != null && parsedObjectCreateOrderModelParam[optionType]){
          const selectedCreateOrder = parsedObjectCreateOrderModelParam[optionType].find(item => item.selected === true);
          if (selectedCreateOrder) {
            qualityTtemTemp.employeeOption =  selectedCreateOrder.name;
          }
        }
        //添加报价员信息quoteModelParam
        if(parsedObjectQuoteModelParam != null && parsedObjectQuoteModelParam[optionType]){
          const selectedQuote = parsedObjectQuoteModelParam[optionType].find(item => item.selected === true);
          if (selectedQuote) {
            qualityTtemTemp.quoteStaffOption =  selectedQuote.name;
          }
        }
        //添加质检员信息
        if(parsedObjectQualityModelParam && parsedObjectQualityModelParam[optionType]){
          const selectedQuality = parsedObjectQualityModelParam[optionType].find(item => item.selected === true);
          if (selectedQuality) {
            qualityTtemTemp.inspectorOption =  selectedQuality.name;
          }
        }
      }
      if(needPush){
        this.orderDetailTableData.push(qualityTtemTemp);
      }
    },

    returnBack(){
      console.log("returnBack");
      this.isOrderDetail = false;

    },
    getHTMLString(priceDetail) {
      // Compose the HTML string by concatenating the parts with the provided createOrderQuoteDetail
      //if(this.orderDetailData.canQualityData){
      //管理员才可以看等级、利润等信息
      if(this.userInfo.roleId === 1){
        console.log(priceDetail);
        return `价格：${priceDetail.price || 0}
          等级：${priceDetail.hjxModelGrade.name || ""}
          基准价：${priceDetail.hjxModelPrice != null && priceDetail.hjxModelPrice.price != null  ? priceDetail.hjxModelPrice.price : 0}
          扣款项：${priceDetail.hjxModelPriceDeductions != null ? priceDetail.hjxModelPriceDeductions.map(
              (item) =>
                `【${item.itemValueName}${item.deduceType === 1
                  ? priceDetail.hjxModelPrice.price * item.price
                  : item.price}】`
            ).join("") : ""}
          价格段预留利润：${priceDetail.modelProfit || 0}
          佣金：${priceDetail.brokerage || 0}
          店员红包：${priceDetail.employeeRedPackage || 0}
          店长红包：${priceDetail.redPackage || 0}
          关键人佣金：${priceDetail.mainPersonCommission || 0}
        `;
      }else{
          return `价格：${priceDetail.price || 0}
          等级：${priceDetail.hjxModelGrade.name || ""}
          佣金：${priceDetail.brokerage || 0}
        `;
      }
    },

    // getHTMLString(priceDetail) {
    //   // Compose the HTML string by concatenating the parts with the provided createOrderQuoteDetail
    //   return `
    //     <div>
    //       <b>价格：${priceDetail.price}</b>
    //     </div>
    //     <div style="margin-top:4px">
    //       等级：${priceDetail.hjxModelGrade.name}
    //       <span style="margin-left:20px">基准价：${priceDetail.hjxModelPrice.price}</span>
    //     </div>
    //     <div style="margin-top:4px">
    //       扣款项：${priceDetail.hjxModelPriceDeductions.map(
    //         (item) =>
    //           `【${item.itemValueName}${item.deduceType === 1
    //             ? priceDetail.queryResult.hjxModelPrice.price * item.price
    //             : item.price}】`
    //       ).join("")}
    //     </div>
    //     <div style="margin-top:4px">价格段预留利润：${priceDetail.modelProfit || 0}</div>
    //     <div style="margin-top:4px">佣金：${priceDetail.brokerage || 0}</div>
    //     <div style="margin-top:4px">店员红包：${priceDetail.employeeRedPackage || 0}</div>
    //     <div style="margin-top:4px">店长红包：${priceDetail.redPackage || 0}</div>
    //     <div style="margin-top:4px">关键人佣金：${priceDetail.mainPersonCommission || 0}</div>
    //   `;
    // },
    getData() {
      this.$api.getData({type: this.selectIndex + 1, merchantId: this.merchantId}).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.statisInfo = res.data;
        }
      })
    },
    // 修改
    queryQualityInfo(orderNO) {
      let self = this;
      this.$api.queryQualityInfo(orderNO, {}).then((res) => {
        if (res.code === 200) {
          self.qualityInfoForm = res.data;
          self.isDlg = true;
        }
      });
    },
    closeQualityDlg() {
      this.isDlg = false;
      this.qualityInfoForm = {};
    },
    // 批量导入
    importSendQualityInfo(file) {
      this.fullscreenQualityLoading = true;
      let formData = new FormData();
      formData.append("file", file);
      this.$api.importBatchQuality(formData).then((res) => {
        this.fullscreenQualityLoading = false;
        if (res.code === 200) {
          this.$message({
            message: "导入成功",
            type: "success",
          });
          this.getOrderList();
        }
      });
      return false;
    },
    getHjxQualityTemplete() {
      window.open((process.env.NODE_ENV === "development" ? "/api2" : "") + `/api/hjx/qualityInfo/getHjxQualityTemplete`, "_blank");
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val

      // 重新请求订单数据
      this.getOrderList()
    },

    // 分页函数
    handleExportSizeChange(val) {
      this.exportPageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleExportCurrentChange(1)
    },
    handleExportCurrentChange(val) {
      this.exportCurrentPage = val

      // 重新请求订单数据
      this.getExportTask();
    },


    formvalidate(formName, cb) {
      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          cb()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    showExportTaskDlg() {
      this.exportTaskDlg = true;
    },

    showExportQualityTaskDlg() {
      this.exportQualityTaskDlg = true;
    },

    addExportTask() {
      let self = this;
      if(!(self.orderProgramFrom.queryMonth !=null && self.orderProgramFrom.queryMonth.length > 1)){
        this.$message({
              message: '查询月份不能为空',
              type: 'error'
            });
        return;
      }
      const [year, month] = self.orderProgramFrom.queryMonth.split('-');
      let convertedDate = year + month.padStart(2, '0');
      self.$api.newExportTask({
        brandId: self.orderProgramFrom.brandId || null,
        queryMonth:convertedDate,
        merchantName:self.orderProgramFrom.merchantName||null,
        createTimeStart: self.orderProgramFrom.createTime instanceof Array && self.orderProgramFrom.createTime.length > 1 ? self.orderProgramFrom.createTime[0] + ' 00:00:00' : null,
        createTimeEnd: self.orderProgramFrom.createTime instanceof Array && self.orderProgramFrom.createTime.length > 1 ? self.orderProgramFrom.createTime[1] + ' 23:59:59' : null,
        modalId: self.orderProgramFrom.modalId || null,
        employeeLike: self.orderProgramFrom.employeeLike || null,
        imei: self.orderProgramFrom.imei || null,
        merchantLike: self.orderProgramFrom.merchantLike || null,
        orderNo: self.orderProgramFrom.orderNo || null,
        status: self.orderProgramFrom.status || null,
        storeLike: self.orderProgramFrom.storeLike || null,
        taskRemark: self.orderProgramFrom.taskRemark || null,
        taskType: self.taskType
      }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          self.closeExportTaskDlg()
        }
      })
    },

    showExportTask() {
      this.exportTaskListDlg = true;
      this.getExportTask();
    },

    getExportTask() {
      let self = this;
      self.$api.getExportTaskList({
        page: self.exportCurrentPage,
        size: self.exportPageSize,
      }).then(res => {

        self.exportTaskData = res.data.records || []
        self.exportTableTotal = res.data.total
      })
    },

    //删除订单
    deleteOrder(id) {
      let self = this
      self.$confirm('是否删除').then(() => {
        self.$api.deleteOrder({id: id}).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getOrderList();
          }
        })
      })

    },
    // 改变异常类型
    changeExceptionType(){
      this.changeStatusForm.expressNo=null;
      this.changeStatusForm.recyclableOrderNo=null;
      this.changeStatusForm.imei=null;
    },

    // 修改订单状态
    changeStatus(formName) {
      let self = this;
      self.formvalidate(formName, () => {
        self.$api.updateOrderStatus({
          orderNo: self.changingOrderNo,
          status: self.changeStatusForm.status,
          exceptionType: self.changeStatusForm.exceptionType,
          expressNo: self.changeStatusForm.expressNo,
          recyclableOrderNo: self.changeStatusForm.recyclableOrderNo,
          imei: self.changeStatusForm.imei
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            self.getOrderList();
            self.closeChangeStausDlg()
          }
        })
      })
    },

    // 取消订单
    cancelOrder() {
      let self = this;
      self.$api.changeOrder({
        orderNo: self.changingOrderNo
      }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '取消订单成功',
            type: 'success'
          });
          self.getOrderList();
          self.closeCancelOrderDlg()
        }
      })

    },


    // 获取订单数据
    getOrderList() {
      let self = this;
      if(!(self.orderProgramFrom.queryMonth !=null && self.orderProgramFrom.queryMonth.length > 1)){
        this.$message({
              message: '查询月份不能为空',
              type: 'error'
            });
        return;
      }
      const [year, month] = self.orderProgramFrom.queryMonth.split('-');
      let convertedDate = year + month.padStart(2, '0');
      self.$api.getQuoterOrderInfoPage({
        page: self.currentPage,
        size: self.pageSize,
        queryMonth:convertedDate,
        createTimeStart: self.orderProgramFrom.createTime instanceof Array && self.orderProgramFrom.createTime.length > 1 ? self.orderProgramFrom.createTime[0] + ' 00:00:00' : null,
        createTimeEnd: self.orderProgramFrom.createTime instanceof Array && self.orderProgramFrom.createTime.length > 1 ? self.orderProgramFrom.createTime[1] + ' 23:59:59' : null,
        orderNo: self.orderProgramFrom.orderNo || null,
        status: self.orderProgramFrom.status || null,
        openOrderNo: self.orderProgramFrom.openOrderNo || null,
        merchantName: self.orderProgramFrom.merchantName || null
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    //  开关取消订单对话框

    openCancelOrderDlg(orderNo) {
      this.changingOrderNo = orderNo;
      this.cancelOrderDlg = true;
    },

    closeCancelOrderDlg() {
      this.cancelOrderDlg = false
    },

    closeExportTaskDlg() {
      this.exportTaskDlg = false
      this.exportQualityTaskDlg = false
    },

    //  开关修改状态对话框
    resetOrderToCurrent(orderNo, createTime) {
      this.$confirm('订单'+orderNo+'进行恢复操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.resetOrderToCurrent({'orderNo':orderNo,'createTime':createTime}).then(res => {
              if (res.code === 200) {
                this.$message({
                  message: '恢复成功',
                  type: 'success'
                });
              }
            })
        }).catch(() => {        
        });
    },

    closeChangeStausDlg() {
      this.changeStatuDlg = false
    },


    // 获取机型，品牌
    getLinkage(row, cb) {
      this.$api.getLinkage({
        page: 1,
        size: 100,
        typeKey: row
      }).then(res => {
        cb(res)
      })
    },


    // 获取导出数据
    getExportOrderData(cb) {
      let self = this
      self.$api.getExportOrderData({
        page: self.currentPage,
        size: self.pageSize,
        brandId: self.orderProgramFrom.brandId || null,
        createTimeStart: self.orderProgramFrom.createTime instanceof Array && self.orderProgramFrom.createTime.length > 1 ? self.orderProgramFrom.createTime[0] + ' 00:00:00' : null,
        createTimeEnd: self.orderProgramFrom.createTime instanceof Array && self.orderProgramFrom.createTime.length > 1 ? self.orderProgramFrom.createTime[1] + ' 23:59:59' : null,
        modalId: self.orderProgramFrom.modalId || null,
        employeeLike: self.orderProgramFrom.employeeLike || null,
        imei: self.orderProgramFrom.imei || null,
        merchantLike: self.orderProgramFrom.merchantLike || null,
        orderNo: self.orderProgramFrom.orderNo || null,
        status: self.orderProgramFrom.status || null,
        storeLike: self.orderProgramFrom.storeLike || null,
      }).then(res => {
        if (res.code === 200) {
          cb(res.data || [])
        }
      })
    },
    // 批量导入
    importSendInfo(file) {
      this.fullscreenLoading = true
      let formData = new FormData()
      formData.append('file', file)
      console.log(file);
      this.$api.importSendInfo(formData).then(res => {
        this.fullscreenLoading = false
        if (res.code === 200) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
          this.getOrderList()
        }
      })
      return false;
    },
    formatDate: (date, pattern) => {
      if (!pattern) {
        pattern = 'YYYY-MM-DD hh:mm:ss';
      }
      let d = new Date(date),
          str = pattern,
          types = ['YYYY', 'MM', 'DD', 'hh', 'mm', 'ss'],
          dates = [d.getFullYear(), d.getMonth() + 1, d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds()];

      for (let i = 0; i < types.length; i++) {
        str = str.replace(types[i], (dates[i] < 10 ? ('0' + dates[i]) : dates[i]));
      }

      return str;
    },

    downloadMater() {
      const defaultCellStyle = {
        font: {name: "Verdana", sz: 11, color: "FF00FF88"},
        fill: {fgColor: {rgb: "FFFFAA00"}}
      };
      const wopts = {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
        defaultCellStyle: defaultCellStyle,
        showGridLines: false
      };
      const wb = {SheetNames: ["Sheet1"], Sheets: {}, Props: {}};


      this.getExportOrderData((data) => {

        console.log(data)

        if (data.length > 0) {


          // 设置导出格式
          let _data = []
          for (let i in data) {
            _data.push({})

            _data[i]['订单编号'] = data[i].orderNO
            _data[i]['分类'] = data[i].categoryName
            _data[i]['品牌'] = data[i].brandName
            _data[i]['型号'] = data[i].modelName
            _data[i]['IMEI'] = data[i].imei
            _data[i]['总价格(含加价金额)'] = data[i].price
            _data[i]['加价金额'] = data[i].raisePrice
            _data[i]['客户姓名'] = data[i].customerName
            _data[i]['客户电话'] = data[i].customerPhone
            _data[i]['客户身份证'] = data[i].idcard
            _data[i]['报价人'] = data[i].quoteName

            _data[i]['订单状态'] = data[i].statusDesc
            _data[i]['店员'] = data[i].employeeName
            _data[i]['门店'] = data[i].storeName
            _data[i]['商户'] = data[i].merchantName

            _data[i]['店员备注'] = data[i].remark
            _data[i]['报价人备注'] = data[i].quoteRemark
            _data[i]['收货备注IMEI'] = data[i].receiveImei
            _data[i]['收货备注库存号'] = data[i].repertoryCode
            _data[i]['收货备注机况'] = data[i].receiveRemark

            _data[i]['下单时间'] = data[i].createTime

            _data[i]['报价时间'] = data[i].quoteTime

            _data[i]['付款时间'] = data[i].payTime

            _data[i]['发货时间'] = data[i].sendTime
            _data[i]['收货时间'] = data[i].receiveTime
            _data[i]['物流单号'] = data[i].expressOrderNo
            _data[i]['物流公司'] = data[i].expressCompany

          }


          wb.Sheets["Sheet1"] = XLSX.utils.json_to_sheet(_data);

          //创建二进制对象写入转换好的字节流
          let tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], {
            type: "application/octet-stream"
          });
          // 保存文件
          FileSaver.saveAs(tmpDown, `${this.formatDate(new Date(), 'YYYY-MM-DD')} - 换机侠订单.xls`);
        }

      });


    },
    // 字符串转字符流
    s2ab(s) {
      if (typeof ArrayBuffer !== "undefined") {
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        let buf = new Array(s.length);
        for (let j = 0; j != s.length; ++j) buf[j] = s.charCodeAt(j) & 0xff;
        return buf;
      }
    }
  },
  created() {
  },
  mounted() {
    let self = this;
     // 是否开启修改
     this.userInfo = JSON.parse(localStorage.getItem('userInfo')).data
     this.userType = this.userInfo.roleId === 1 ? 1 : 0
    if(this.userType==0){
      this.orderProgramFrom.merchantName='太力优服'
    }
    self.getOrderList()

    
  },

}
</script>
<style lang="less" scoped>
.upload-demo {
  display: inline;
}

.flex-style {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.title-style {
  border-bottom: 1px solid #ededed;
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-column {
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  margin-right: 80px;

  .fs30 {
    font-size: 30px;
    font-weight: 550;
    margin-top: 14px;
  }
}
.order-link {
  /* 添加类似超链接的样式 */
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
.content {
  background-color: white;
  padding: 20px;
}

.el-table .separator-row {
  height: 20px;
  background-color: #ccc; /* 设置为灰色背景 */
  border-color: #ccc; /* 设置边框颜色为灰色，使其与背景一致 */
  padding: 8px; /* 添加一些内边距以增加美观性 */
  border: 1px solid #ccc; /* 添加边框 */
}
.gray-background {
  background-color: #ccc; /* 设置为灰色背景 */
  border-color: #ccc; /* 设置边框颜色为灰色，使其与背景一致 */
  padding: 8px; /* 添加一些内边距以增加美观性 */
    border: 1px solid #ccc; /* 添加边框 */
}
</style>
